import {
  ADDEDIT_WALLET_INVALID_REQUEST,
  ADDEDIT_WALLET_FAILED,
  ADDEDIT_WALLET_SUCCESS,
  ADDEDIT_WALLET_INVALID_NAME,
  LOADING_WALLET_ADDEDIT,
  ADDEDIT_WALLET_ALREADY_EXIST,
  RESET_ADDEDIT_WALLET,
  SHOW_SELECTED_WALLET,
  RESET_SELECTED_WALLET,
} from "../types";

const initialState = {
  isLoading: false,
  success: false,
  failed: false,
  invalidRequest: false,
  invalidName: false,
  selectedWalletDetail: {},
  status: "",
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOADING_WALLET_ADDEDIT:
      return {
        ...state,
        isLoading: true,
        success: false,
        failed: false,
        invalidRequest: false,
        alreadyExist: false,
        invalidName: false,
        status: "",
      };

    case ADDEDIT_WALLET_FAILED:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: true,
        invalidRequest: false,
        alreadyExist: false,
        invalidName: false,
        status: "Add wallet failed!",
      };
    case ADDEDIT_WALLET_INVALID_REQUEST:
      return {
        ...state,
        isLoading: false,
        success: false,
        invalidRequest: true,
        failed: false,
        alreadyExist: false,
        invalidName: false,
        status: "Something went wrong!",
      };

    case ADDEDIT_WALLET_SUCCESS:
      return {
        ...state,
        isLoading: false,
        success: true,
        invalidRequest: false,
        failed: false,
        alreadyExist: false,
        invalidName: false,
        status: "Wallet is successfully created!",
      };

    case ADDEDIT_WALLET_ALREADY_EXIST:
      return {
        ...state,
        isLoading: false,
        success: false,
        invalidRequest: false,
        failed: false,
        alreadyExist: true,
        invalidName: false,
        status: "Wallet already exist!",
      };

    case ADDEDIT_WALLET_INVALID_NAME:
      return {
        ...state,
        isLoading: false,
        success: false,
        invalidRequest: false,
        failed: false,
        alreadyExist: false,
        invalidName: true,
        status: "Invalid Wallet Name!",
      };

    case RESET_ADDEDIT_WALLET:
      return (state = initialState);

    case SHOW_SELECTED_WALLET:
      return {
        ...state,
        selectedWalletDetail: action.payload,
      };

    case RESET_SELECTED_WALLET:
      return {
        ...state,
        selectedWalletDetail: {},
      };

    default:
      return state;
  }
};
